//Utility pages, not displayed on the navbar:
// import { Login } from 'pages/Login';

//Displayed on the navbar:
import {Frontpage} from 'pages/Frontpage';
import {Invoices} from './Invoices';
import {ComponentType} from 'react';
import {Agreements} from "./Agreements";
import {CustomerCards} from "./CustomerCards";
import {DocumentRow} from "./DocumentRows";
import {Inventory} from "./Inventory";
import {Bookings} from "./Bookings";
import {DispensingOrders} from "./DispensingOrders";
import {Login} from "./Login";
import { UserProfile } from './UserProfile';
import Tanks from './Tanks';
import { ConfirmEmail } from './ConfirmEmail';
import { SaleOrders } from './SaleOrders';
import { NewElectricityAgreement } from './NewElectricityAgreement';
import Register from './Register';
import { ElectricityConsumption } from './electricity-consumption/ElectricityConsumption';
import { PaymentProcessor } from './PaymentProcessor';
import AsCustomerLoader from './AsCustomerLoader';
import RedirectLoader from './RedirectLoader';
import { NewChargingAgreement } from './NewChargingAgreement';
import { ViewElectricityOffer } from './ViewElectricityOffer';
import { CustomerApplications } from './CustomerApplications';
import { CustomerContacts } from './CustomerContacts';
import { APPLICATIONS_PAGE_TITLE, CARDS_PAGE_TITLE } from 'common/constants';
import GhgEmissionReport from './GhgEmissionReport';

export interface IPages {
    title: string;
    component: ComponentType<any>;
    showInNav: boolean;
    isUtility: boolean;
    isPublic: boolean,
    requiredRoles: Array<CustomerRole> | null
    onlyShowForPersons: boolean;
    onlyShowForCompany?: boolean;
    onlyShowForRepresentative?: boolean;
    mustHaveGroupId: Array<String> | null;
    footerHidden?: boolean;
    headerHidden?: boolean;
}

export interface IActivePage {
    path: string;
    isPublic: boolean,
    requiredRoles: Array<CustomerRole> | null
    onlyShowForPersons: boolean;
    onlyShowForCompany?: boolean;
    onlyShowForRepresentative?: boolean;
    mustHaveGroupId: Array<String> | null;
    footerHidden?: boolean;
    headerHidden?: boolean;
}

export enum CustomerRole {
    AUTHENTICATED_USER = 'AUTHENTICATED_USER', // "Autentitud kasutaja",
    ADMIN = 'ADMIN', // "Peakasutaja",
    SUPPLIER = 'SUPPLIER', // "Tarnija",
    DISPENSER = 'DISPENSER', // "Väljastaja",
    CARRIER = 'CARRIER', // "Vedaja",
    BOOKER = 'BOOKER', // "Broneerija"
    VIEW_AGREEMENTS = 'VIEW_AGREEMENTS',
    VIEW_DOCUMENTS = 'VIEW_DOCUMENTS',
    VIEW_DOCUMENT_ROWS = 'VIEW_DOCUMENT_ROWS',
    VIEW_CARDS = 'VIEW_CARDS',
    VIEW_SALE_ORDERS = 'VIEW_SALE_ORDERS',
    TANK_OWNER = 'TANK_OWNER',
    ELECTRICITY_CUSTOMER = 'ELECTRICITY_CUSTOMER',
    VIEW_KHG_REPORT = 'VIEW_KHG_REPORT'
}

export const Pages: IPages[] = [
    {
        title: 'login',
        component: Login,
        showInNav: false,
        isUtility: true,
        isPublic: true,
        requiredRoles: null,
        onlyShowForPersons: false,
        mustHaveGroupId: null,
    },
    {
        title: 'esileht',
        component: Frontpage,
        showInNav: true,
        isUtility: false,
        isPublic: false,
        requiredRoles: null,
        onlyShowForPersons: false,
        mustHaveGroupId: null,
    },
    {
        title: 'arved',
        component: Invoices,
        showInNav: true,
        isUtility: false,
        isPublic: false,
        requiredRoles: [CustomerRole.ADMIN, CustomerRole.VIEW_DOCUMENTS],
        onlyShowForPersons: false,
        mustHaveGroupId: null,
    },
    {
        title: 'väljavõte',
        component: DocumentRow,
        showInNav: true,
        isUtility: false,
        isPublic: false,
        requiredRoles: [CustomerRole.ADMIN, CustomerRole.VIEW_DOCUMENT_ROWS],
        onlyShowForPersons: false,
        mustHaveGroupId: null,
    },
    {
        title: 'KHG-raport',
        component: GhgEmissionReport,
        showInNav: true,
        isUtility: false,
        isPublic: false,
        requiredRoles: [CustomerRole.ADMIN, CustomerRole.VIEW_KHG_REPORT],
        onlyShowForPersons: false,
        mustHaveGroupId: null,
    },
    {
        title: 'lepingud',
        component: Agreements,
        showInNav: true,
        isUtility: false,
        isPublic: false,
        requiredRoles: [CustomerRole.ADMIN, CustomerRole.VIEW_AGREEMENTS],
        onlyShowForPersons: false,
        mustHaveGroupId: null,
    },
    {
        title: CARDS_PAGE_TITLE,
        component: CustomerCards,
        showInNav: true,
        isUtility: false,
        isPublic: false,
        requiredRoles: [CustomerRole.ADMIN, CustomerRole.VIEW_CARDS],
        onlyShowForPersons: false,
        mustHaveGroupId: null,
    },
    {
        title: APPLICATIONS_PAGE_TITLE,
        component: CustomerApplications,
        showInNav: true,
        isUtility: false,
        isPublic: false,
        requiredRoles: [CustomerRole.ADMIN, CustomerRole.VIEW_CARDS],
        onlyShowForPersons: false,
        mustHaveGroupId: null,
    },
    {
        title: 'laoseis',
        component: Inventory,
        showInNav: true,
        isUtility: false,
        isPublic: false,
        requiredRoles: [CustomerRole.SUPPLIER],
        onlyShowForPersons: false,
        mustHaveGroupId: null,
    },
    {
        title: 'broneeringud',
        component: Bookings,
        showInNav: true,
        isUtility: false,
        isPublic: false,
        requiredRoles: [CustomerRole.BOOKER],
        onlyShowForPersons: false,
        mustHaveGroupId: null,
    },
    {
        title: 'väljastuskorraldused',
        component: DispensingOrders,
        showInNav: true,
        isUtility: false,
        isPublic: false,
        requiredRoles: [CustomerRole.DISPENSER],
        onlyShowForPersons: false,
        mustHaveGroupId: null,
    },
    {
        title: 'tellimused',
        component: SaleOrders,
        showInNav: true,
        isUtility: false,
        isPublic: false,
        requiredRoles: [CustomerRole.ADMIN, CustomerRole.VIEW_SALE_ORDERS],
        onlyShowForPersons: false,
        onlyShowForCompany: true,
        mustHaveGroupId: null,
    },
    {
        title: 'mahutid',
        component: Tanks,
        showInNav: true,
        isUtility: false,
        isPublic: false,
        requiredRoles: [CustomerRole.TANK_OWNER],
        onlyShowForPersons: false,
        mustHaveGroupId: null,
    },
    {
        title: 'elektritarbimine',
        component: ElectricityConsumption,
        showInNav: true,
        isUtility: false,
        isPublic: false,
        requiredRoles: [CustomerRole.ELECTRICITY_CUSTOMER],
        onlyShowForPersons: false,
        mustHaveGroupId: null,
    },    
    {
        title: 'profiil',
        component: UserProfile,
        showInNav: false,
        isUtility: false,
        isPublic: false,
        requiredRoles: null,
        onlyShowForPersons: false,
        mustHaveGroupId: null,
    },
    {
        title: 'confirm-id-credit/:id',
        component: ConfirmEmail,
        showInNav: false,
        isUtility: true,
        isPublic: true,
        requiredRoles: null,
        onlyShowForPersons: false,
        mustHaveGroupId: null,
    },
    {
        title: 'elekter/leping',
        component: NewElectricityAgreement,
        showInNav: false,
        isUtility: false,
        isPublic: false,
        requiredRoles: null,
        onlyShowForPersons: false,
        mustHaveGroupId: null,
        footerHidden: true
    },
        {
        title: 'elekter/vaata-pakkumist/:id',
        component: ViewElectricityOffer,
        showInNav: false,
        isUtility: false,
        isPublic: false,
        requiredRoles: null,
        onlyShowForPersons: false,
        mustHaveGroupId: null,
        footerHidden: true
    },
    {
        title: 'laadimine/leping',
        component: NewChargingAgreement,
        showInNav: false,
        isUtility: false,
        isPublic: false,
        requiredRoles: null,
        onlyShowForPersons: false,
        mustHaveGroupId: null,
        footerHidden: true
    },
    {
        title: 'registreeri',
        component: Register,
        showInNav: false,
        isUtility: false,
        isPublic: false,
        requiredRoles: null,
        onlyShowForPersons: false,
        onlyShowForCompany: false,
        mustHaveGroupId: null,
        footerHidden: true
    },    
    {
        title: 'process-payment',
        component: PaymentProcessor,
        showInNav: false,
        isUtility: true,
        isPublic: true,
        requiredRoles: null,
        onlyShowForPersons: false,
        mustHaveGroupId: null,
    },
    {
        title: 'as-customer',
        component: AsCustomerLoader,
        showInNav: false,
        isUtility: true,
        isPublic: true,
        requiredRoles: null,
        onlyShowForPersons: false,
        mustHaveGroupId: null,
    },
    {
        title: 'redirect',
        component: RedirectLoader,
        showInNav: false,
        isUtility: true,
        isPublic: true,
        requiredRoles: null,
        onlyShowForPersons: false,
        mustHaveGroupId: null,
        headerHidden: true
    },
    {
        title: 'kasutajad',
        component: CustomerContacts,
        showInNav: true,
        isUtility: false,
        isPublic: false,
        requiredRoles: [CustomerRole.ADMIN],
        onlyShowForPersons: false,
        onlyShowForCompany: true,
        mustHaveGroupId: null,
        onlyShowForRepresentative: true,
    }
    // {
    //     title: 'suveralli',
    //     component: SummerGame,
    //     showInNav: true,
    //     isUtility: false,
    //     isPublic: false,
    //     requiredRoles: null,
    //     onlyShowForPersons: true,
    //     mustHaveGroupId: SUMMER_GAME_GROUPS,
    // },
];
